export const COMPANY_SIZE_OPTIONS = [
  { value: '1-10', label: '1 - 10' },
  { value: '11-50', label: '11 - 50' },
  { value: '51-200', label: '51 - 200' },
  { value: '201-500', label: '201 - 500' },
  { value: '500+', label: '500+' },
];

export const INDUSTRY_OPTIONS = [
  { value: 'Aerospace & Defense', label: 'Aeroespacial e Defesa' },
  { value: 'Agriculture & Food', label: 'Agronegócio e Alimentação' },
  {
    value: 'Automotive & Transportation',
    label: 'Automotivo e Transporte',
  },
  { value: 'Chemicals & Materials', label: 'Química e Materiais' },
  {
    value: 'Construction & Built Environment',
    label: 'Construção Civil',
  },
  {
    value: 'Consumer Packaged Goods (CPG)',
    label: 'Bens de Consumo (CPG)',
  },
  { value: 'Education', label: 'Educação' },
  { value: 'Entertainment', label: 'Entretenimento' },
  { value: 'Finance', label: 'Finanças' },
  { value: 'Government & Nonprofit', label: 'Governo e ONGs' },
  { value: 'Healthcare', label: 'Saúde' },
  { value: 'Hospitality & Tourism', label: 'Hotelaria e Turismo' },
  { value: 'Industrial & Energy', label: 'Indústria e Energia' },
  { value: 'Legal & Compliance', label: 'Jurídico e Compliance' },
  { value: 'Lifestyle & Leisure', label: 'Lifestyle e Lazer' },
  { value: 'Logistics & Supply Chain', label: 'Logística e Supply Chain' },
  { value: 'Luxury & Fashion', label: 'Luxo e Moda' },
  { value: 'News & Media', label: 'Mídia e Comunicação' },
  {
    value: 'Professional Services & Agencies',
    label: 'Serviços Profissionais e Agências',
  },
  { value: 'Real Estate & PropTech', label: 'Imobiliário e PropTech' },
  { value: 'Retail & E-commerce', label: 'Varejo e E-commerce' },
  { value: 'Sports', label: 'Esportes' },
  { value: 'Technology', label: 'Tecnologia' },
  { value: 'Telecommunications', label: 'Telecomunicações' },
  { value: 'Other', label: 'Outro' },
];

export const REFERRAL_SOURCE_OPTIONS = [
  { value: 'google', label: 'Google' },
  { value: 'reddit', label: 'Reddit' },
  { value: 'twitter', label: 'Twitter/X' },
  { value: 'linkedin', label: 'LinkedIn' },
  { value: 'friend', label: 'Amigo/Colega' },
  { value: 'blog', label: 'Blog/Artigo' },
  { value: 'github', label: 'GitHub' },
  { value: 'other', label: 'Outro' },
];

export const USER_ROLE_OPTIONS = [
  { value: 'founder', label: 'Fundador/CEO' },
  { value: 'product_manager', label: 'Product Manager' },
  { value: 'engineering', label: 'Engenharia/Desenvolvimento' },
  { value: 'support_lead', label: 'Líder de Suporte' },
  { value: 'marketing', label: 'Marketing' },
  { value: 'sales', label: 'Vendas' },
  { value: 'other', label: 'Outro' },
];
